import { render, staticRenderFns } from "./Frontpage.vue?vue&type=template&id=49803e86&scoped=true&"
import script from "./Frontpage.vue?vue&type=script&lang=js&"
export * from "./Frontpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49803e86",
  null
  
)

export default component.exports